import {applyBasketState} from './set-state-user';

const selectors = {
    basket: '#basket_line .basket_fly, .basket_fly.basket-fly',
    opener: '.basket-fly__opener .edge-menu__item.clicked',
    close: '.basket_fly .close, .basket_fly .back_button',
    tabs: '.basket-fly__tabs > li',
    contents: '.tabs_content.basket > li',
    removeButtons: '.basket_sort .remove_all_basket',
};

const classes = {
    opened: 'basket-fly--opened',
    closed: 'basket-fly--closed',
    activeTab: 'basket-fly__tab_active',
    activeContent: 'basket-fly__content_active',
    activeOpener: 'edge-menu__item--active',
};

function getBasket() {
    return document.querySelector(selectors.basket);
}

function isOpened(basket) {
    return basket.classList.contains(classes.opened);
}

function clearActive(basket) {
    basket.querySelectorAll(selectors.opener).forEach((opener) => {
        opener.classList.remove(classes.activeOpener);
    });
    basket.querySelectorAll(selectors.tabs).forEach((tab) => {
        tab.classList.remove('basket-fly__tab_active');
    });
    basket.querySelectorAll(selectors.contents).forEach((content) => {
        content.classList.remove('basket-fly__content_active');
    });
}

function openBasket(basket, type) {
    basket.classList.add(classes.opened);
    basket.classList.remove(classes.closed);
    basket.setAttribute('aria-hidden', 'false');

    if (type) {
        applyBasketState(basket, type);
    }
}

export function closeBasket(basket) {
    basket.classList.remove(classes.opened);
    basket.classList.add(classes.closed);
    basket.setAttribute('aria-hidden', 'true');
    clearActive(basket);
}

async function toggleBasket(basket, type) {
    const current = basket.querySelector(`${selectors.contents}.${classes.activeContent}`);
    const currentType = current ? current.getAttribute('item-section') : '';

    if (!isOpened(basket)) {
        openBasket(basket, type);
        return;
    }

    if (type && currentType !== type) {
        applyBasketState(basket, type);
        return;
    }

    closeBasket(basket);
}

function handleOpenerClick(event) {
    const opener = event.target.closest(selectors.opener);
    if (!opener) return;

    const basket = opener.closest('.basket_fly');
    if (!basket) return;

    event.preventDefault();
    toggleBasket(basket, opener.dataset.type);
}

function handleTabClick(event) {
    const tab = event.target.closest(selectors.tabs);
    if (!tab) return;

    const basket = tab.closest('.basket_fly');
    if (!basket) return;

    event.preventDefault();
    applyBasketState(basket, tab.dataset.type);
}

function handleCloseClick(event) {
    const close = event.target.closest(selectors.close);
    if (!close) return;

    const basket = close.closest('.basket_fly') || getBasket();
    if (!basket) return;

    event.preventDefault();
    closeBasket(basket);
}

function handleOutsideClick(event) {
    const basket = getBasket();
    if (!basket || !isOpened(basket)) return;
    if (event.target.closest('.basket_fly')) return;

    closeBasket(basket);
}
function initBasketFly() {
    const basket = getBasket();
    if (!basket) return;

    closeBasket(basket);

    basket.addEventListener('click', handleOpenerClick);
    basket.addEventListener('click', handleTabClick);
    basket.addEventListener('click', handleCloseClick);

    document.addEventListener('click', handleOutsideClick);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBasketFly);
} else {
    initBasketFly();
}
